import { computed, unref } from 'vue';

import { paramCase, propsFactory } from '@components/utils';

import type { MaybeRef } from '@components/utils';
import type { ComputedRef, PropType } from 'vue';

export type TDirection = typeof allowedDirection[number];
export interface IDirectionProps {
  direction: TDirection;
}
export interface IUseDirection {
  directionClasses: ComputedRef<string>;
}

export const allowedDirection = ['horizontal', 'vertical'] as const;
export const makeDirectionProps = propsFactory(
  {
    /**
     * Расположение горизонтальное или вертикальное
     */
    direction: {
      type: String as PropType<TDirection>,
      default: 'horizontal',
      available: allowedDirection,
      validator: (value: TDirection) => allowedDirection.includes(value)
    }
  },
  'direction'
);

export function useDirection(props: MaybeRef<IDirectionProps>, name: string): IUseDirection {
  const directionClasses = computed(() => {
    const { direction } = unref(props);

    return `${paramCase(name)}__direction--${direction}`;
  });

  return { directionClasses };
}
